import { connect } from 'react-redux';
import Modal from 'comp/modals/contacts_list';
import * as selectors from 'selectors';

const mapToProps = state => ({
  user: state.user,
  conv_id: selectors.getSelectedConvId(),
  tmp_pm: state.ui.tmp_pm
});

export default connect(mapToProps)(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/ContactsList.js